<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">{{ data.headline }}</div>

    <!-- Help text (valid-feedback) always shows, with d-block, and gives way only to the field's own
         message; see rendition-dialog.component.html. A column the audio mode does not write is
         disabled and says so. The rules across rows are in app-audio-errors below. -->
    <div [formGroup]="row" class="modal-body cl-form">
      <div>
        <label class="form-label" for="audio_channels">Channels</label>
        <input [class.invalid]="showErrors && row.get('channels').errors" class="it-audio-field-channels" formControlName="channels" id="audio_channels" min="1" placeholder="source" step="1" type="number">
        @if (showErrors && row.get('channels').errors?.min) {
          <p class="invalid-feedback d-block">Must be at least 1.</p>
        } @else if (!data.applies('channels')) {
          <p class="valid-feedback d-block">Not used by the current audio mode.</p>
        } @else {
          <p class="valid-feedback d-block">The channel layout of this rendition: 2 is stereo, 6 is 5.1, 8 is 7.1. Blank keeps the source's.</p>
        }
      </div>

      <div class="cl-spacing-small">
        <label class="form-label" for="audio_codec">Codec</label>
        <select class="form-select it-audio-field-codec" formControlName="codec" id="audio_codec">
          @for (c of data.codecsFor(row); track c) {
            <option [ngValue]="c">{{ data.codecLabel(c) }}</option>
          }
        </select>
        @if (!data.applies('codec')) {
          <p class="valid-feedback d-block">Not used by the current audio mode.</p>
        } @else {
          <p class="valid-feedback d-block">The audio codec. HE-AACv2 is only defined for stereo, so it is offered on 2 channels only.</p>
        }
      </div>

      <div class="cl-spacing-small">
        <label class="form-label" for="audio_bitrate">Bitrate</label>
        <input [class.invalid]="showErrors && row.get('bitrate').errors" class="it-audio-field-bitrate" formControlName="bitrate" id="audio_bitrate" placeholder="source" type="text">
        @if (showErrors && row.get('bitrate').errors?.bitrate) {
          <p class="invalid-feedback d-block">{{ bitrateHint }}</p>
        } @else if (!data.applies('bitrate')) {
          <p class="valid-feedback d-block">Not used by the current audio mode.</p>
        } @else {
          <p class="valid-feedback d-block">The target bitrate of this rendition. Each codec of a layout can have its own.</p>
        }
      </div>

      <div class="cl-spacing-small">
        <label class="form-label" for="audio_samplerate">Sample rate</label>
        <input class="it-audio-field-samplerate" formControlName="samplerate" id="audio_samplerate" placeholder="source" step="1" type="number">
        @if (!data.applies('samplerate')) {
          <p class="valid-feedback d-block">Not used by the current audio mode.</p>
        } @else {
          <p class="valid-feedback d-block">The sample rate in Hz, for example 48000. Blank keeps the source's.</p>
        }
      </div>

      <div class="cl-spacing-small">
        <label class="form-label" for="audio_display">Menu name</label>
        <input class="it-audio-field-display" formControlName="display" id="audio_display" placeholder="none" type="text">
        @if (!data.applies('display')) {
          <p class="valid-feedback d-block">Not used by the current audio mode.</p>
        } @else {
          <p class="valid-feedback d-block">The name the player shows for this layout in its audio menu. Blank means none.</p>
        }
      </div>

      <div aria-labelledby="audio_layout_policy_label" class="cl-spacing-small" role="group">
        <!-- Both checkboxes are written by the same modes, so the heading fades when they do. -->
        <label [class.cl-faded]="!data.applies('required') && !data.applies('allow_downmix')" class="form-label it-audio-layout-policy-label" id="audio_layout_policy_label">Layout policy</label>
        <!-- The checkbox's own id is the one on its input, which is what the dialog disables by. -->
        <app-dl-checkbox
          [description]="data.applies('required') ? 'Deliver this layout even when no source track is in it.' : 'Not used by the current audio mode.'"
          [inactive]="!data.applies('required')"
          checkboxId="audio_required"
          formControlName="required"
          label="Required"></app-dl-checkbox>
        <div class="cl-spacing-small">
          <app-dl-checkbox
            [description]="data.applies('allow_downmix') ? 'Allows this layout to be derived from a wider source. Nothing is ever up-mixed.' : 'Not used by the current audio mode.'"
            [inactive]="!data.applies('allow_downmix')"
            checkboxId="audio_allow_downmix"
            formControlName="allow_downmix"
            label="Accept downmix"></app-dl-checkbox>
        </div>
      </div>

      @if (showErrors) {
        <app-audio-errors [errors]="data.setErrors()" />
      }
    </div>

    <div class="modal-footer">
      <span class="modal-footer-left">
        <button (click)="dialogRef.close(false)" class="btn cl-color-secondary it-cancel" type="button">
          <span>Cancel</span>
        </button>
      </span>
      <span class="modal-footer-center"></span>
      <span class="modal-footer-right">
        <button (click)="dialogRef.close(true)" [disabled]="row.invalid" class="btn cl-color-primary it-ok" type="button">
          <span>{{ data.actionName }}</span>
        </button>
      </span>
    </div>
  </div>
</div>
